import { StateUtils } from 'utils';

const MESSAGE = 'MESSAGE_GLOBAL_REDUCER';
const messageTag = StateUtils.actionType(MESSAGE);

export const REMOVE_MESSAGE = messageTag`REMOVE_MESSAGE`;
export const ON_MESSAGE = messageTag`SET_MESSAGE`;
export const MESSAGE_ERROR = messageTag`MESSAGE_ERROR`;
export const MESSAGE_SUCCESS = messageTag`MESSAGE_SUCCESS`;
export const MESSAGE_WARNING = messageTag`MESSAGE_WARNING`;

export interface MessageState {
  description: string;
  type?: string;
}
